export const Environment = {
    dev: 'dev',
    uat: 'uat',
    prod: 'prod',
    local: 'local '
};